import {
  SiteDetailsBuildsEnabledFieldsFragmentDoc,
  SiteDetailsBuildsEnabledFieldsFragment,
} from "@modules/site/settings/fragments.generated"

import { useToggleBuildFlagMutation } from "@modules/site/settings/queries.generated"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { useCurrentUser } from "@modules/auth"

export function useToggleBuilds(siteId: string) {
  const { currentUser } = useCurrentUser()

  const [toggleBuildsMutation, { loading }] = useToggleBuildFlagMutation()
  const [setError, errorAlert] = useTriggerErrorAlert()

  const toggleBuilds = () => {
    setError(null)
    return toggleBuildsMutation({
      variables: {
        siteId,
        userId: currentUser?.id,
      },
      update: (proxy, { data }) => {
        if (!data?.toggleBuildFlag?.success) {
          return
        }

        const fragmentInfo = {
          id: `Site:${siteId}`,
          fragment: SiteDetailsBuildsEnabledFieldsFragmentDoc,
        }

        const site = proxy.readFragment<SiteDetailsBuildsEnabledFieldsFragment>(
          fragmentInfo
        )

        if (!site) {
          return
        }

        site.buildsEnabled = !site.buildsEnabled

        proxy.writeFragment<SiteDetailsBuildsEnabledFieldsFragment>({
          ...fragmentInfo,
          data: site,
        })
      },
      optimisticResponse: {
        toggleBuildFlag: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return [toggleBuilds, { loading, errorAlert }] as const
}
